module.exports = __webpack_public_path__ + "img/black-overlay-left.53c22ad8.svg";